import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginAuditRecord } from './model/login-audit-record';
import { Observable, of } from 'rxjs';
import { ComplianceReport, ComplianceReportingSearchSpec } from './model/compliance-reporting';


@Injectable()
export class ReportsService {

  constructor(public http:HttpClient) { 

  }

  getLoginReport(startDate:Date, endDate: Date, successFilter: LoginAuditSuccessInclusion) : Observable<LoginAuditRecord[]> {
    return this.http.get<LoginAuditRecord[]>(this.getLoginReportUrl(startDate, endDate, successFilter));
  }

  getLoginReportUrl(startDate:Date, endDate: Date, successFilter: LoginAuditSuccessInclusion):string{
    let startDt = startDate <= endDate? startDate : endDate;
    let endDt = endDate >= startDate? endDate : startDate;    
    return `/api/reports/login-audit?FromDate=${this.formatDate(startDt)}&ToDate=${this.formatDate(endDt)}&SuccessFilter=${successFilter}`;
  }

  formatDate(d: Date) {
    //To deal with converting the javascript 0 based month numbering, add 1 to bring it into parity
    let month = (d.getMonth()+1).toString();
    month = month.length == 1? "0"+month : month;
    return d.getFullYear().toString() +"-"+ month +"-"+d.getDate();
    }
    searchMetaDataAsComplianceReport(spec: ComplianceReportingSearchSpec): Observable<ComplianceReport[]> {
        return this.http.post<ComplianceReport[]>(`api/reports/get-compliance-data`, spec);
    }

 

}


export enum LoginAuditSuccessInclusion
{
    Both = 0,
    OnlySuccess = 1,
    OnlyFailure = 2
}